import React from 'react'
import { StyleSheet, View, Text } from '@react-pdf/renderer'

const TableFooter: React.FC<{dataReferente: string}> = ({dataReferente}) => {

    const styles = StyleSheet.create({
        container: {
            position: 'absolute',
            bottom: '0',
            left: '20px',
            right: '20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            width: '100%',
            paddingVertical: '12px',
            borderTop: '1px solid black',
        },
        leftText: {
            fontSize: '8px',
        },
        rightText: {
            fontSize: '8px',
            fontWeight: 'bold',
        }
    })

    return(

        <View style = {styles.container} fixed>
            <Text style = {styles.leftText}>{`054_FMEI Rev.02 ${dataReferente}`}</Text>
            <Text style = {styles.rightText} render={({ pageNumber, totalPages }) => (`pág ${pageNumber} de ${totalPages}`)} fixed />
        </View>

    )

}

export default TableFooter